import styled from 'styled-components';

export const Csvlink = styled.div`
  display: none;
`;